// extracted by mini-css-extract-plugin
export default {"error":"login-pass_error__VDjQ-"};